import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import s from 'react-prefixr';
import DomainElements from '../../../components/DomainElements/DomainElements';
import ReactPinchZoomPan from './ReactPinchZoomPan';
import './PinchView.scss';
import ComponentsAccordion from '../../../components/ComponentsAccordion/ComponentsAccordion';
import LelySpinner from '../muiWrappers/LelySpinner/LelySpinner';

/**
 * PinchView component.
 * @param {Object} props - Object which contains all methods props of component.
 * @param {function} props.getSelectedItemDetails - Send details of the clicked canbus element ,
 * @param {Object} props.metaData - Contains the data of all details in the machine,
 * @param {Number} props.initialScale - Current zoom of the component,
 * @param {Number} props.maxScale -  Max zoom scale,
 * @param {Array} props.backgroundImage - Image of the canbus,
 * @param {Function} props.onPinchStart - Fires on dragging the zoomed Image ,
 * @param {Boolean} [props.disableClick]  - Disable click on components
 * @param {Array} [props.liveDataMessage] - Live data from signalR
 * @param {Number} props.containerRatio - Ration of the pinchView component
 */

function PinchView({
  getSelectedItemDetails,
  metaData,
  initialScale,
  maxScale,
  backgroundImage,
  onPinchStart,
  containerRatio,
  disableClick,
  liveDataMessage,
  children,
}) {
  /** Initialize is preloader active state */
  const { isPreloaderActive } = useSelector((state) => state.preloader);
  /** Latest selected component name */
  const [selectedComponentName, setSelectedComponentName] = useState();

  useEffect(() => {
    // Update sideBar
    updateLiveSideBarDataComponent();
  }, [liveDataMessage]);

  function updateLiveSideBarDataComponent() {
    /** Find component object in frontendMetadata */
    const obj = metaData.find(
      (o) => o.componentIdentifier === selectedComponentName,
    );
    /** Update sidebar component */
    if (obj) {
      getSelectedItemDetails(obj.componentData, selectedComponentName);
    }
  }

  /**
   * Scale component on zoom.
   * @param {Object} obj - Object which contains all methods of class.
   * @return {Object} - Return transform css style
   */
  function getContentStyle(obj) {
    return {
      transform: `scale(${obj.scale}) translateY(${obj.y}px)translateX(${obj.x}px)`,
    };
  }

  //  /**
  //  * On double click zoom in or zoom out.
  //  * @param {Object} e - Object which contains all methods of class.
  //  */
  // function onDblClick(e){
  //   console.log('dblClicks')
  //   e.preventDefault()
  //   console.log(initialScale)
  //   return initialScale + 1
  // }

  return (
    <ReactPinchZoomPan
      initialScale={initialScale}
      maxScale={maxScale}
      render={(obj) => {
        return (
          <div className="wrapper">
            <div
              className="child"
              style={{ paddingTop: `${containerRatio.toFixed(2)}%` }}
            >
              <div className="sub-child">
                <div className="content-style" style={s(getContentStyle(obj))}>
                  {!isPreloaderActive ? (
                    <div
                      className="backgroundImage-wrapper"
                      // onDoubleClick={onDblClick}
                      style={{ backgroundImage: `url(${backgroundImage})` }}
                    >
                      <DomainElements
                        getSelectedItemDetails={(domainData, domainTitle) => {
                          setSelectedComponentName(domainTitle);
                          getSelectedItemDetails(domainData, domainTitle);
                        }}
                        domainData={metaData}
                        disableClick={disableClick}
                      />
                    </div>
                  ) : (
                    <div className="spinner-style">
                      <LelySpinner />
                    </div>
                  )}
                </div>
                <ComponentsAccordion domainData={metaData} />
              </div>
            </div>
            {children}
          </div>
        );
      }}
      onPinchStart={onPinchStart}
    />
  );
}

PinchView.propTypes = {
  containerRatio: PropTypes.number,
  initialScale: PropTypes.number,
  maxScale: PropTypes.number,
  onPinchStart: PropTypes.func,
  backgroundImage: PropTypes.string.isRequired,
  getSelectedItemDetails: PropTypes.func.isRequired,
};

export default PinchView;
